let _global = [];
let _get_var = function(key) {
	return typeof _global[key] != "undefined" ? _global[key] : null;
};
let _set_var = function(key, val) {
	_global[key] = val;
};
let _msg = function(msg) {
	console.info(msg);
};

//判断环境 安卓为window.jsBridge 苹果为window.webkit
let _has_api = (function() {
	return typeof window.jsBridge != "undefined" ||
		typeof window.webkit != "undefined" ?
		true :
		false;
})();
//navigator.userAgent.toLowerCase()判断浏览器的类型
let _system_model = (function() {
	//将获取的运行环境变为小写
	let userAgent = navigator.userAgent.toLowerCase();
	//判断是不是苹果
	if (userAgent.indexOf("iphone") != -1) {
		return "iPhone";
		//判断是不是安卓
	} else if (userAgent.indexOf("android") != -1) {
		return "Android";
	} else {
		//都不是return未知
		return "Unknown";
	}
})();
//定义一个_call_app_func函数
let _call_app_func = function(method, params = {}) {
	//没有传递过来的参数就返回空对象
	// params = params || {};
	//使用_msg函数 查看 函数名以及参数信息
	_msg("call app function:" + method + "(" + JSON.stringify(params) + ")");
	//判断如果没有安卓和苹果方法 就return false
	if (!_has_api) {
		return false;
	}
	//判断判断浏览器的类型是苹果的话
	if (_system_model == "iPhone") {
		console.info('走进了iphone的判断');
		//定义参数  使用try 和catch捕获错误
		try {
			if (method == "changeWebToolBar" || method == "changeWebRefresh") {
				return window.webkit.messageHandlers[method].postMessage(JSON.stringify(params));
			} else {
				method = "app" + method.replace(method[0], method[0].toUpperCase());
				let requestData = {
					selector: method,
					params: params,
					type: "app"
				};
				console.info(requestData);
				return prompt(JSON.stringify(requestData));
			}
			// console.info("方法名" + method, "函数接收参数" + params);
		} catch (e) {
			//如果错误的话 就调用_msg 打印错误信息
			_msg(method + "调用失败：" + JSON.stringify(e));
		}
	} else {
		//如果是安卓的话
		console.info('走进了安卓');
		try {
			console.info("方法名" + method, "参数" + params);
			//判断params是否等于空对象 如果等于 就直接通过window.jsBridge调用传递过来的函数并执行
			// if (params == {}) return window.jsBridge[method]();
			// //如果不等于空对象 return 就调用函数的时候将参数序列化进行传递
			// else return window.jsBridge[method](JSON.stringify(params));
			if (JSON.stringify(params) === '{}') {
				console.log('参数等于空对象');
				return window.jsBridge[method]();
			} else {
				console.log('参数不等于空对象');
				return window.jsBridge[method](JSON.stringify(params));
			}
		} catch (e) {
			//如果错误 调用函数打印错误信息
			_msg(method + "调用失败：" + JSON.stringify(e));
		}
	}
};

var app = {
	//控制原生导航栏是否显示
	//参数为true隐藏反之显示
	changeWebToolBar: function(val) {
		return _call_app_func('changeWebToolBar', {
			"hideWebToolBar": val
		})
	},
	//h5控制原生是否开启下拉刷新
	//参数为true隐藏反之显示
	changeWebRefresh: function(val) {
		console.log("val: ", val);
		return _call_app_func('changeWebRefresh', {
			'hideWebRefresh': val
		})
	},
	//   /* 刘海(状态栏)安全高度 */
	getSafeAreaTop: function() {
		if (_has_api) {
			return _call_app_func("getSafeAreaTop");
			// Toast(value)
			// let screenWidth = Math.max(parseInt(window.screen.width), 375);
			// return (7.5 / screenWidth) * parseInt(value);
		} else {
			return 0.2;
		}
	},
	/* 设置状态栏文本颜色 */
	setStatusBar: function(style, color) {
		if (style == _get_var("style") && color == _get_var("color")) {
			_msg("status bar not changed");
			return false;
		}
		_set_var("style", style);
		_set_var("color", color);
		if (_has_api) {
			return _call_app_func("setStatusBar", {
				style: style,
				color: color
			});
		}
		_msg("set status bar style[" + style + ":" + color + "]");
	},
	//   /* 返回APP首页 */
	// goHome: function() {
	// 	if (_has_api) {
	// 		return _call_app_func("goHome");
	// 	} else {
	// 		return true;
	// 	}
	// },
	// 关闭当前页
	closeWebView: function() {
		if (_has_api) {
			return _call_app_func("closeWebview");
		} else {
			return true;
		}
	},
	nativeShare: function(val) {
		return _call_app_func("nativeShare", val);
	},
	//   /* 设置状态栏文本颜色 */
	//   setStatusBar: function(style, color) {
	//     if (style == _get_var("style") && color == _get_var("color")) {
	//       _msg("status bar not changed");
	//       return false;
	//     }
	//     _set_var("style", style);
	//     _set_var("color", color);
	//     if (_has_api) {
	//       return _call_app_func("setStatusBar", {
	//         style: style,
	//         color: color
	//       });
	//     }
	//     _msg("set status bar style[" + style + ":" + color + "]");
	//   },
	//   /* 底部安全高度 */
	//   getSafeAreaBottom: function(url) {
	//     if (_has_api) {
	//       let value = _call_app_func("getSafeAreaBottom");
	//       return parseInt(value) / 100;
	//     } else {
	//       return 0;
	//     }
	//   },

	//   /* 关闭Webview */
	//   closeWebView: function() {
	//     if (_has_api) {
	//       return _call_app_func("closeWebView");
	//     } else {
	//       return true;
	//     }
	//   },
	//   getScreenHeight: function() {
	//     return (
	//       (parseInt(window.screen.height) / parseInt(window.screen.width)) * 7.5
	//     );
	//   },
	//   hasApi: function() {
	//     return _has_api;
	//   }
};

export default app;
